import React, { ReactNode } from "react";
import { css, Theme, useTheme } from "@emotion/react";

import ContentCombine from "core/Components/ContentCombine";

type Props = {
    children: ReactNode,
};

const ItemDescription: React.FC<Props> = ({ children }) => {
    const theme: Theme = useTheme();

    const style = css`
        margin-top: 48px;

        ${theme.breakpoints.between('lg', 'xl')} {
            margin-top: 37px;
        }

        ${theme.breakpoints.only('md')} {
            margin-top: 29px;
        }

        ${theme.breakpoints.only('sm')} {
            margin-top: 33px;
        }
        
        ${theme.breakpoints.down('xs')} {
            margin-top: 40px;
        }
        
        #list-left {
            margin-left: 18px;

            ${theme.breakpoints.down('sm')} {
                margin-left: 20px;
                width: calc(100% - 20px);
            }

            li {
                margin-right: 0;

                ${theme.breakpoints.up('md')} {
                    padding-left: 12px;
                }
            }
        }

        #list-center {
            counter-reset: list;
            margin: 10px auto;
            width: 50%;

            li {
                text-align: left;
            }
        }

        ol {
            counter-reset: list;

            > li {
                padding-left: 0 !important; // Since our number is a custom ::before, padding is not applied correctly
                position: relative;
                list-style: none;
            }
        }

        ol > li:before {
            counter-increment: list;
            content: counter(list) ") ";
            margin-left: -20px;
            padding-right: 3px;
        }

        ${theme.breakpoints.up('md')} {
            ol {
                &#list-left {
                    margin-left: 30px;

                    > li:before {
                        margin-left: -30px;
                        padding-right: 10px;
                    }
                }
            }
        }

        ${theme.breakpoints.down('sm')} {
            ol {
                &#list-center {
                    > li:before {
                        padding-left: 2px !important;
                    }
                }
            }
        }
    `;

    return (
        <div css={style}>
            <ContentCombine fontSizeType={'19'}>
                {children}
            </ContentCombine>
        </div>
    );
};

export default ItemDescription;